import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectAuthToken, selectAuthVendor } from '../store/reducers';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        Accept: 'application/json',
      },
    });

    const token = this.store.selectSignal(selectAuthToken);
    if (token()) {
      request = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + token(),
          'X-Vendor-Id':
            this.store.selectSignal(selectAuthVendor)()?.id?.toString() ?? '',
        },
      });
    }

    return next.handle(request);
  }
}
